import React from "react"



export default function Header() {
    return (
        <header className="header">
            <img className="header-image" src="/images/Troll Face.png"  alt="navimg" />
            <h3 className="header-title">MemeGenerator</h3>
        </header>
    )
}